import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api/client'
import { keys } from '@/lib/api/keys'

/**
 * Is the signed-in user a platform admin?
 *
 * The same probe the /admin route guard makes, under the same query key, so
 * the answer is fetched once and shared. A non-admin gets a 404 — the browser
 * learns nothing it could not learn by typing /admin. Calls the endpoint
 * directly rather than importing the admin feature, which must stay in its
 * own chunk.
 */
export function usePlatformAdmin(enabled = true) {
  return useQuery({
    queryKey: keys.admin.providers(),
    queryFn: () => api.get<unknown[]>('/admin/v1/ai/providers'),
    retry: false,
    staleTime: 60_000,
    enabled,
  })
}
